import { UserType } from './UserType.enum';
import { AppType } from 'src/app/shared/enums/AppType.enum';

export class LoginRequest {

  public appType: AppType = null;
  public isOrganization = false;
  public recaptchaToken: string = null;

  constructor(
    public username: string,
    public password: string,
    public externalAccessToken: string = null,
    public provider: string = null,
    public userType: UserType = null,
    public emailSessionToken: string = null
  ) { }
}
